import { render, staticRenderFns } from "./oneStopProcessingConsult.vue?vue&type=template&id=6baa70ea&scoped=true&"
import script from "./oneStopProcessingConsult.vue?vue&type=script&lang=js&"
export * from "./oneStopProcessingConsult.vue?vue&type=script&lang=js&"
import style0 from "./oneStopProcessingConsult.vue?vue&type=style&index=0&id=6baa70ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baa70ea",
  null
  
)

export default component.exports